<template>
    <div>
        <default-button @click.native="isOpen = true" icon="pencil" size="xxs" :loading="loading" :disabled="loading">
            {{ $t('formula.edit') }}
        </default-button>

        <portal to="modal">
            <element-modal :open="isOpen" @close="reset" is-closable :title="$t('formula.edit')">
                <template #body>
                    <div class="flex flex-col items-start space-y-2">
                        <template v-for="(entry, index) in formula">
                            <template v-if="!offsetIndex || index !== offsetIndex && index !== offsetIndex + 1">
                                <template v-if="typeof entry === 'object'">
                                    <span v-if="entry.type === 'field'"
                                          class="px-2 py-0.5 rounded-lg bg-red-200 dark:bg-red-800">
                                        {{ $helper.storeManager.getFieldByNumber(entry.value).label }}
                                    </span>

                                    <template v-if="entry.type === 'number'">
                                        <input-group :value="entry.value" @input="entry.value = parseFloat($event)" name="number" type="number" step="0.0001"/>
<!--                                        <input-group v-if="auth.user.isAdmin" :value="entry.value" @input="entry.value = parseFloat($event)" name="number" type="number" step="0.0001"/>-->
<!--                                        <span v-else class="px-2 py-0.5 rounded-lg bg-green-200 dark:bg-green-800">{{ entry.value }}</span>-->
                                    </template>
                                </template>

                                <template v-else>
                                    <span
                                        class="px-2 py-0.5 rounded-lg bg-purple-200 dark:bg-purple-800 text-center font-bold">
                                        {{ $t('formula.operation_icon.' + entry) }}
                                        {{ $t('formula.operation.' + entry) }}
                                    </span>
                                </template>
                            </template>
                        </template>

                        <toggle class="flex-shrink-0 w-full" v-model="hasOffset" name="has_offset" :label="$t('formula.offset')" active-color="bg-green-600"/>

                        <template v-if="hasOffset">
                            <input-currency v-model="formula[offsetIndex + 1].value"/>
                        </template>
                    </div>
                </template>

                <template #footer>
                    <default-button class="ml-2" @click.native="submit">
                        {{ $t('form.save') }}
                    </default-button>
                </template>
            </element-modal>
        </portal>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isOpen: false,
            formula: [],
        };
    },

    mounted() {
        this.validateFormula(this.value);
        this.ensureHasOffset(this.hasOffset);
    },

    computed: {
        auth() {
            return auth;
        },
        hasOffset: {
            get() {
                return !!this.offsetIndex;
            },
            set(value) {
                this.ensureHasOffset(value);
            },
        },
        offsetIndex() {
            let index = this.formula.findIndex(entry => typeof entry === 'string' && entry === 'offset');

            return this.formula.length - 2 === index ? index : null;
        },
    },

    methods: {
        submit() {
            this.$emit('input', this.formula);
            this.isOpen = false;
        },
        reset() {
            this.validateFormula(this.value);
            this.isOpen = false;
        },
        ensureHasOffset(shouldHaveOffset) {
            let index = this.offsetIndex;

            if (!index && shouldHaveOffset) {
                this.formula.push('offset');
                this.formula.push({
                    'type': 'number',
                    'value': 0,
                });
            }

            if (index && !shouldHaveOffset) {
                this.formula.splice(index, 2);
            }
        },
        validateFormula(value) {
            value = _.cloneDeep(value);
            let formula = [];

            value.forEach((entry, index) => {
                if (index % 2 === 1 && entry === 'offset' && this.value.length - 2 !== index) {
                    return;
                }

                formula.push(_.cloneDeep(entry));
            });

            this.formula = formula;
        },
    },

    watch: {
        value: {
            deep: true,
            handler(value) {
                this.validateFormula(value);
            },
        },
    },
};
</script>
